
import { Home } from 'lucide-react';

const Header2 = () => {
  const handleHomeClick = () => {
    // Navigate to home page - adjust this according to your routing setup
    window.location.href = '/';
  };

  return (
    <header className="bg-white shadow-lg border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 sm:py-4">
        <div className="flex items-center justify-between">
          
          {/* Logo Section */}
          <div className="flex items-center space-x-2 sm:space-x-3">
            <div className="flex items-center space-x-2">
              <img
                src="/logo.png"
                alt="VGL Logo"
                className="w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 object-contain"
              />
              <span className="text-lg sm:text-xl md:text-2xl font-bold text-gray-800">
                VGL Trans Express
              </span>
            </div>
          </div>
          
          {/* Home Button */}
          <button
            onClick={handleHomeClick}
            className="flex items-center space-x-2 bg-gradient-to-r from-blue-500 to-teal-500 hover:from-blue-600 hover:to-teal-600 text-white px-4 sm:px-6 py-2 sm:py-3 rounded-xl font-semibold transition-all duration-300 shadow-lg hover:shadow-xl text-sm sm:text-base"
          >
            <Home className="w-4 h-4 sm:w-5 sm:h-5" />
            <span>Acasă</span>
          </button>
          
        </div>
      </div>
    </header>
  );
};

export default Header2;